<template>
  <default>
    <div class="cust-motor-wrap">
      <motor-start-page />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import MotorStartPage from '@/components/motor/MotorStartPage';

export default {
  name: 'CustomerMotorStart',
  components: { Default, MotorStartPage },
  metaInfo: { title: 'Motor insurance — Quote' },
};
</script>

<style src="@/assets/css/customer-motor.css"></style>
